import { mediaQueries } from '@do/walrus';
import styled from 'styled-components';
import { FormWrap as CommonFormWrap } from '../Common';

const NewFormWrap = styled(CommonFormWrap)`
  box-shadow: 0px 6px 20px -6px rgba(11, 43, 158, 0.15);
  border-radius: 24px;
  margin-top: 10vh;

  &.isCreditBanner {
    margin-top: 18vh;
    ${mediaQueries.medium} {
      margin-top: 10vh;
    }
  }

  &.isCreditBannerSplit {
    margin-top: 25vh;
    ${mediaQueries.medium} {
      margin-top: 10vh;
    }
  }
`;

export default NewFormWrap;
